var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 10,
  viewBox: "0 0 13 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.9745 0.530256C11.1819 0.332837 11.4578 0.223695 11.7442 0.225862C12.0305 0.228028 12.3047 0.341333 12.5091 0.541867C12.7134 0.742402 12.8319 1.01448 12.8395 1.30069C12.847 1.58691 12.7431 1.86486 12.5496 2.07592L6.67613 9.42149C6.57513 9.53027 6.45323 9.61757 6.31773 9.67817C6.18222 9.73876 6.03588 9.77141 5.88747 9.77416C5.73906 9.77691 5.59162 9.7497 5.45396 9.69416C5.3163 9.63863 5.19126 9.5559 5.0863 9.45093L1.19124 5.55586C1.08277 5.45479 0.995763 5.3329 0.935421 5.19747C0.875078 5.06205 0.842631 4.91585 0.840016 4.76761C0.8374 4.61937 0.86467 4.47212 0.920197 4.33465C0.975725 4.19717 1.05837 4.07229 1.16321 3.96746C1.26805 3.86262 1.39293 3.77997 1.5304 3.72444C1.66787 3.66892 1.81512 3.64165 1.96336 3.64426C2.1116 3.64688 2.2578 3.67932 2.39323 3.73967C2.52866 3.80001 2.65054 3.88701 2.75162 3.99548L5.83411 7.0765L10.9466 0.562642C10.9558 0.551308 10.9656 0.540496 10.976 0.530256H10.9745Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/check.0f1c7e2575d50cab5be3712058bdcf81.svg";